import { Menu } from './classes/Menu.js';

document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('#header');
    if (menu)
        new Menu(menu);
});
